import API, { GraphQLQuery, GraphQLResult, GraphQLSubscription } from '@aws-amplify/api';
import { GRAPHQL_AUTH_MODE } from '@aws-amplify/api-graphql';
import { Observable } from 'zen-observable-ts';
import { AWSAppSyncRealTimeProvider } from '@aws-amplify/pubsub';
import { runPaidolSessionCheck } from 'app/services/session/paidolSessionCheck';

export interface GraphQLOptions {
  query: string;
  variables?: { [key: string]: any };
  authMode?: GRAPHQL_AUTH_MODE;
  authToken?: string;
  userAgentSuffix?: string;
}

export const graphqlRequest = <T>(
  options: GraphQLOptions | any,
  dispatch: (action: any) => void,
  additionalHeaders?: {
    [key: string]: string;
  }
): T extends GraphQLQuery<T>
  ? Promise<GraphQLResult<T>>
  : T extends GraphQLSubscription<T>
  ? Observable<{
      provider: AWSAppSyncRealTimeProvider;
      value: GraphQLResult<T>;
    }>
  : Promise<GraphQLResult<any>> | Observable<object> => {
  try {
    let query: string;
    let variables: any;
    let authMode: GRAPHQL_AUTH_MODE | undefined;
    let authToken: string | undefined;
    let userAgentSuffix: string | undefined;

    if (options.query) {
      query = options.query;
      variables = options.variables;
      authMode = options.authMode;
      authToken = options.authToken;
      userAgentSuffix = options.userAgentSuffix;
    } else {
      query = options.query || options.definitions?.[0]?.loc?.source?.body || '';
      variables = options.variables;
    }

    const operation = API.graphql<T>({
      query,
      variables,
      authMode,
      authToken,
      userAgentSuffix,
    });

    if (typeof (operation as Promise<GraphQLResult<T>>).then === 'function') {
      return (operation as Promise<GraphQLResult<T>>)
        .then((result) => {
          return result;
        })
        .catch(async (error) => {
          if (error.errors?.length > 0 && error.errors[0].errorType === 'Unauthorized') {
            await runPaidolSessionCheck(dispatch);
          }
          throw error;
        }) as any;
    } else {
      return operation;
    }
  } catch (error) {
    console.error('❌ GraphQL Error:', error);
    throw error;
  }
};

export const Middleware = {
  graphqlRequest,
};
